import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { ClientToolsRegistry } from '@core/tellent-assistant-logic';
import { ClientToolRenderPartComponent } from '@core/tellent-assistant-ui';

import { presenterIdForKind } from './present-dispatcher.helpers';

type PresentArgs = { kind?: string } & Record<string, unknown>;

@Component({
  selector: 'rt-assistant-present',
  imports: [ClientToolRenderPartComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <tellent-assistant-client-tool-render-part [component]="component()" [args]="payload()" />
  `,
})
export class PresentDispatcherComponent {
  private readonly registry = inject(ClientToolsRegistry);

  protected readonly component = computed(() => {
    const presenterId = presenterIdForKind(this.args()?.kind);
    return presenterId ? this.registry.byId(presenterId)?.component : undefined;
  });

  // The presenter expects only its own payload, so drop the `kind` selector.
  protected readonly payload = computed(() => {
    const { kind: _kind, ...rest } = this.args() ?? {};
    return rest;
  });

  public readonly args = input.required<PresentArgs>();
}
